import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-clearance-success',
  templateUrl: './clearance-success.component.html',
  styleUrls: ['./clearance-success.component.scss']
})
export class ClearanceSuccessComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();

}